<template>
  <div class="tree-content">
    <div class="search" v-if="showSearch">
      <el-input
        style="width: calc(100% - 70px);margin-right: 12px;"
        size="small"
        v-model="nodeName"
        placeholder=""
        clearable
      ></el-input>
      <el-button type="primary" size="small" @click="handleGetTreeList"
        >查询</el-button
      >
    </div>
    <div class="search" v-else>
      <el-input
        style="width: 100%"
        size="small"
        v-model="nodeName"
        placeholder=""
        clearable
      ></el-input>
    </div>
    <div class="tree">
      <el-tree
        ref="tree"
        :data="treeList"
        :props="defaultProps"
        node-key="id"
        default-expand-all
        highlight-current
        :indent="2"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
        empty-text="暂无数据"
      >
        <template slot-scope="{ node }">
          <span :title="node.label">{{ node.label }}</span>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "treeComponents",
  props: {
    treeList: Array,
    defaultProps: Object,
    activeNode: Number,
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      nodeName: "",
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;

      return data.name.indexOf(value) !== -1;
    },
    handleGetTreeList() {
      this.$refs.tree.filter(this.nodeName);
      // this.$emit('handleGetTreeList')
    },
    handleNodeClick(data, node) {
      this.$emit("handleNodeChange", { ...data });
    },
    handleSetCurrentKey(id) {
      this.$refs["tree"].setCurrentKey(id);
    },
  },
  watch: {
    nodeName(val) {
      // this.$refs.tree.filter(val)
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .search {
    width: 100%;
    margin-bottom: 12px;
  }
  .tree {
    width: 100%;
    height: calc(100% - 46px);
    overflow: auto;
  }
}
</style>
